import { Box, Button as ThemeUiButton } from "theme-ui";
import { useSelector } from "react-redux";
import flow from "lodash/fp/flow";
import filter from "lodash/fp/filter";
import join from "lodash/fp/join";
import map from "lodash/fp/map";

import { useTranslation } from "hooks";
import { selectUserChoicesForUi } from "store/app";
import { Button, HorizontalScrollView } from "components";
import { ArrowLeftIcon, ArrowRightIcon } from "components/icons";
import * as styles from "./SelectedValuesBar.styles";

function getLabelValues(shouldJoinWith) {
  return flow(
    filter(({ values }) => !values || values.length > 0),
    map(({ label, value, values, joinValuesWith, isIncluded }) => {
      if (values) {
        return getLabelValues(joinValuesWith)(values);
      }
      return [
        label,
        [`<strong>${value}</strong>`, isIncluded && `<em>${isIncluded}</em>`]
          .filter(Boolean)
          .join(" "),
      ]
        .filter(Boolean)
        .join(": ");
    }),
    join(shouldJoinWith)
  );
}

export default function SelectedValuesBar({ displayReviewModal }) {
  const { t } = useTranslation();

  const userChoicesForUi = useSelector(selectUserChoicesForUi(t));

  return (
    <Box sx={styles.selectedValuesBar} data-cy="selected-values-bar">
      <HorizontalScrollView
        sideGutter={0}
        itemGap={20}
        height={40}
        sideButtonWidth={40}
        justifyContent="flex-start"
        leftButtonComponent={({ onClick, disabled }) => (
          <ThemeUiButton
            variant="unstyled"
            onClick={onClick}
            disabled={disabled}
            sx={styles.leftArrowButton}
          >
            <ArrowLeftIcon sx={styles.arrowIcons} />
          </ThemeUiButton>
        )}
        rightButtonComponent={({ onClick, disabled }) => (
          <ThemeUiButton
            variant="unstyled"
            onClick={onClick}
            disabled={disabled}
            sx={styles.rightArrowButton}
          >
            <ArrowRightIcon sx={styles.arrowIcons} />
          </ThemeUiButton>
        )}
      >
        <Box sx={styles.selectedValues}>
          {userChoicesForUi.map(({ title, values, joinValuesWith }) => (
            <Box key={title} sx={styles.item}>
              {title && `${title}: `}

              <Box
                as="span"
                dangerouslySetInnerHTML={{
                  __html:
                    values.length > 0
                      ? getLabelValues(joinValuesWith)(values)
                      : "--",
                }}
              />
            </Box>
          ))}
        </Box>
      </HorizontalScrollView>

      <Button sx={styles.viewYourSpecsButton} onClick={displayReviewModal}>
        {t("View your specs")}
      </Button>
    </Box>
  );
}
